import React from 'react';

/**
 * BLOCK: pull_quote
 * ACF layout name: `block_pull_quote`
 *
 * Fields:
 *  - eyebrow  (text)
 *  - quote    (textarea)
 *  - author   (text)
 *
 * The inline dark quote panel used mid-article (currently the Einstein quote on
 * Sound-Infused Renewal). Distinct from `block_quote` (QuoteBlock), which is a
 * full-bleed section between page bands.
 */

interface PullQuoteProps {
  eyebrow?: string;
  quote: string;
  author: string;
}
export function PullQuote({
  eyebrow = 'A guiding perspective',
  quote,
  author
}: PullQuoteProps) {
  return <aside className="relative overflow-hidden border border-rose/60 bg-charcoal px-7 py-12 text-cream shadow-soft sm:px-10 sm:py-14" data-id="element-157" data-mp="1tzw8m801m8sm">
      <span aria-hidden="true" className="pointer-events-none absolute -right-4 -top-8 font-serif text-[13rem] leading-none text-rose/10" data-id="element-158" data-mp="1k05ew8jb3xtl">
        “
      </span>
      <div className="relative" data-id="element-159" data-mp="3edwlt0a943lc">
        {eyebrow && <p className="text-xs font-medium tracking-[0.26em] text-rose uppercase" data-id="element-160" data-mp="3eeg5alfjv01h">
            {eyebrow}
          </p>}
        <blockquote className="mt-7 max-w-2xl font-serif text-4xl italic leading-[1.04] text-cream sm:text-5xl" data-id="element-161" data-mp="v1umdf1g4ef5">
          “{quote}”
        </blockquote>
        <cite className="mt-7 block border-t border-cream-100/20 pt-5 text-xs font-medium tracking-[0.2em] text-cream-100/75 uppercase not-italic" data-id="element-162" data-mp="h3d0znz0je0e">
          — {author}
        </cite>
      </div>
    </aside>;
}